<template>
  <div>
    <div id="pdfDom">
      <div class="centerbox">
        <iframe style="width:100%;height:700px;" :src="fileUrl"></iframe>
      </div>
    </div>
    <div class="btnpdf">
      <!-- <el-button size="mini" type="success" @click.prevent="toSubscribe">去预约</el-button> -->
      <el-button size="mini" type="primary" @click.prevent="getDown">下载报告</el-button>
      <el-button size="mini" @click="dialogClse">取消</el-button>
    </div>
  </div>
</template>
<script>
import {
  DownReport,
} from '@/api/evaluation/index';
export default {
  props: ['topicId', 'planId', 'statezc','rTit'],
  components:{  },
  data() {
    return {
      reportList: '',
      isShowTable: false,
      states: 0,
      Tearclist: [],
      tableData: [],
      reportName: '',
      userList: {},
      reportTime: '',
      dialogFormVisible: false,//预约
      reportdialog: false,
      makedialog: false,
      tearchId: null,
      fileUrl: '',
    };
  },
  created(){
    this.reportName = this.rTit ? this.rTit : '民警性格问卷测评报告';
    this.handleCreate();
  },
  methods: {
    dialogClse() {
      this.$emit('close');
    },
    // 查看报告
    handleCreate() {
      let para = {
        userId: this.$store.state.User.ids,
        topicId: this.topicId,
        planId: this.planId,
      };

      DownReport(para).then(res=>{
        this.fileUrl = res.result;
      })
    },
    //关闭预约
    allColse() {
      this.dialogFormVisible = false;
      this.reportdialog = false;
      this.makedialog = false;
    },
    // 点击取消预约窗口
    colseReport(val){
      this.titlenew = '预约咨询';
      this.tearchId = val;
      this.reportdialog = false;
      this.makedialog = true;
    },
    // 点击立即预约
    goBackmake() {
      this.makedialog = true;
      this.reportdialog = false;
    },
    //去预约
    toSubscribe(){
      this.dialogFormVisible = true;
      this.reportdialog = true;
    },
    //下载文件
    getDown(){
      let a = document.createElement('a');
      a.setAttribute("href", this.fileUrl);
      a.setAttribute("download", '测评报告');
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      if ('download' in document.createElement('a') == false){
        this.$message.error('此浏览器不支持下载!');
      }
    }
  },
};
</script>
<style scoped>
.centerbox {
  background-color: #f5f7fa;
  /* padding: 20px 40px 20px 40px; */
  color: #333;
  /* width: 1100px; */
  width: 100%;
  margin: 0 auto;
}
.centertxt {
  background-color: #fff;
  border-radius: 5px;
  text-align: center;
  padding: 20px 0;
}
.centertxtlistt {
  background-color: #fff;
  border-radius: 5px;
  padding: 20px 0;
}

.centerheader {
  font-size: 48px;
  padding-top: 80px;
  margin-bottom: 10px;
  font-weight: bold;
}

.msg {
  padding-top: 80px;
}
.msg div {
  font-size: 20px;
  padding-bottom: 20px;
}

.centerheadercp {
  font-size: 20px;
  margin-bottom: 10px;
  font-weight: bold;
  padding-left: 30px;
  text-align: center;
}
.centerTime{
  font-size: 16px;
  padding-left: 30px;
  text-align: center;
}

.centerheadercpbg {
  font-size: 22px;
  margin-bottom: 10px;
  font-weight: bold;
  padding-left: 30px;
  text-align: center;
}

.centerborder {
  display: block;
  height: 0.5px;
  width: 850px;
  background: #000;
  margin: 0 auto;
  margin-top: 5px;
}
.rsulttxt {
  width: 830px;
  margin: 0 auto;
  font-size: 16px;
  color: #333;
}
.centsr {
  line-height: 28px;
  margin-top: 15px;
}

.counselorbox {
  display: flex;
  padding: 40px 0;
  justify-content: center;
}
.counselorimgbox {
  width: 155px;
  padding: 0 10px;
  cursor: pointer;
}
.counseloname {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-top: 15px;
}
.counselot {
  font-size: 14px;
  margin-top: 20px;
  text-align: center;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
}
.counselottwo {
  font-size: 14px;
  margin-top: 10px;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  height: 57px;
}
.counselorimg {
  display: block;
  height: 115px;
  width: 115px;
  border-radius: 50%;
  margin: 0 auto;
}

.btnpdf {
  display: flex;
  justify-content: end;
  margin-top: 15px;
}
.makeBtn {
  margin: 0 auto;
  width: 160px;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  background-color: #1492ff;
  margin-top: 20px;
  cursor: pointer;
}
.stipulationBox{
  min-height: 640px;
}
</style>